export const baseURL = "https://ferrywheel.egchat.live/";
export const adminBaseURL = "https://admin.egchat.live/";
export const key = "8{vWkyP/zyJne9s";
